var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheFooter',[_c('div',[_vm._v(" Book of Turtles "),_c('span',{staticClass:"ml-1"},[_vm._v("© 2020.")])]),_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"mr-1"},[_vm._v("Powered by")]),_c('a',{attrs:{"href":"http://leopardtechlabs.com"}},[_vm._v("Leopard Tech Labs Pvt. Ltd")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }